import type { BaseTranslation } from "../i18n-types";

const pt = {
	WELCOME_LONG: "Bem-vindo ao Unicorn Digital Courtroom",
	WELCOME: "Bem-vindo {name}!",
	JOIN_ROOM_DESCRIPTION:
		"Junte-se a uma sala listada abaixo ou crie sua própria sala!",
	NO_ROOM: "Não vê a sala que procura? Crie sua própria sala.",
	CREATE_ROOM: "Criar Sala",
	ROOM: "Sala",
	ACCESSIBILITY_SETTINGS: "Configurações de acessibilidade",
	ACCESSIBILITY_SETTINGS_DESCRIPTION:
		"Altere as configurações de acessibilidade aqui",
	CONTRAST: "Contraste",
	SELECT_DISPLAY_NAME:
		"Por favor, insira o nome de exibição que gostaria de usar",
	SOMETHING_WENT_WRONG: "Ops! Algo deu errado.",
	GO_BACK: "Voltar",
	GO_BACK_TO_ROOM: "Voltar para Sala",
	EXPAND: "Expandir",
	EXPORT: "Exportar",
	JOIN_ROOM: "Entrar na Sala",
	ROOM_ENDED_TITLE: "Sala Encerrada",
	ROOM_ENDED_DESCRIPTION:
		"A sala foi encerrada, você será redirecionado para a tela inicial",
	RENAME_FAILED: "Falha ao Renomear.",
	TRANSCRIPT_DISCLAIMER:
		"Uma transcrição baseada nos oradores identificados. Você deve falar por mais de 7 segundos para ser identificado.",
	CHANGE_SPEAKER_TITLE: "Alterar Orador",
	CHANGE_SPEAKER_DESCRIPTION: "altere o nome e a cor do orador aqui",
	PREVIEW_MESSAGE: "Esta é uma mensagem de pré-visualização",
	COLOR: "Cor",
	NAME: "Nome",
	CANCEL: "Cancelar",
	LANGUAGE: "Idioma",
	SAVE: "Salvar",
	ROOM_ID: "ID da Sala",
	ROOM_ID_FORM_PLACEHOLDER: "Digite o ID da sala para entrar",
	ROOM_ID_FORM_REQUIRED: "O ID da sala é necessário para entrar",
	ROOM_ID_FORM_MIN_LENGTH: "O ID da sala deve ter 17 caracteres",
	LOGIN: "Entrar",
	ROOM_COL: "Sala:",
	LANGUAGE_COL: "Idioma",
	END_ROOM: "Encerrar Sala",
	JOIN_NOW: "Entrar Agora",
	LOGIN_FORM: {
		TOAST_TITLE: "Logado!",
		TOAST_DESCRIPTION: "Agora você pode criar/entrar em uma sala!",
		DISPLAY_NAME: "Nome de Exibição",
		DISPLAY_NAME_FORM_PLACEHOLDER: "Digite o nome de exibição",
		DISPLAY_NAME_FORM_SHORT:
			"O nome de exibição deve ter pelo menos 3 caracteres",
		DISPLAY_NAME_FORM_LONG:
			"O nome de exibição deve ter no máximo 32 caracteres",
		DISPLAY_NAME_FORM_REQUIRED: "O nome de exibição é obrigatório",
	},
	PROFILE_FORM: {
		TITLE: "Complete seu Perfil",
		DESCRIPTION: "Por favor, insira seu nome de exibição para começar",
		TOAST_SUCCESS_TITLE: "Perfil Atualizado!",
		TOAST_SUCCESS_DESCRIPTION: "Seu perfil foi salvo com sucesso.",
		TOAST_ERROR_TITLE: "Falha na Atualização",
		TOAST_ERROR_DESCRIPTION:
			"Falha ao atualizar seu perfil. Por favor, tente novamente.",
		SUBMIT_BUTTON: "Salvar Perfil",
	},
	DIARIZATION: {
		UNDETECTED: "Não detectado",
		ACCURACY: "Precisão",
		ID: "ID",
		LEXICAL: "Lexical",
		ITN: "ITN",
		MASKED_ITN: "ITN mascarado",
		LANGUAGE: "Idioma",
		ORIGINAL_TEXT: "Texto Original",
		SPEAKER: "Falante",
	},
	NO_ROOMS_LIST: "Ops, não foi possível encontrar nenhuma sala.",
	SEARCH_FOR_A_ROOM: "Buscar uma sala",
	AUTH_ERROR_DESCRIPTION:
		"Houve um problema ao autenticar você. Por favor, atualize a página.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "Excluir Sala",
		DESCRIPTION: "Tem certeza que deseja excluir esta sala?",
		CANCEL: "Cancelar",
		DELETE: "Excluir",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "Sala Criada",
		DESCRIPTION: "Sua sala está pronta para entrar.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION: "Defina um nome para sua sala para que os outros possam ver.",
		NAME_LABEL: "Nome da Sala",
		NAME_PLACEHOLDER: "Digite o nome da sala",
		LANGUAGE: "Idioma",
		LANGUAGE_PLACEHOLDER: "Selecione um idioma",
		AUTO_DETECT: "Auto-Detectar",
		ENGLISH_US: "Inglês (Estados Unidos)",
		ENGLISH_IN: "Inglês (Índia)",
		ARABIC_KSA: "Árabe (Arábia Saudita)",
		SPANISH_CR: "Espanhol (Costa Rica)",
		CATALAN_ES: "Catalão (Espanha)",
		PORTUGUESE_PT: "Português (Portugal)",
		PORTUGUESE_BR: "Português (Brasil)",
		ESTONIAN_EE: "Estoniano (Estônia)",
		RUSSIAN_RU: "Russo (Rússia)",
		MALTESE_MT: "Maltês (Malta)",
		FILIPINO_PH: "Filipino (Filipinas)",
		SPANISH_MX: "Espanhol (México)",
		CHINESE_CN: "Chinês (Mandarim)",
		VIETNAMESE_VN: "Vietnamita (Vietnã)",
		KOREAN_KR: "Coreano (Coreia)",
		HINDI_IN: "Hindi (Índia)",
		PERSIAN_IR: "Persa (Irã)",
		LANGUAGE_DESCRIPTION:
			"Selecione um idioma para a sala, você não poderá alterar o idioma da sala posteriormente.",

		INCPERSONDEFAULT: "Doe,Jane",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "Audiência de adequação subsequente",
		SCHEDULEDEFAULT: "28/11/2023, 10h30 PST",
		ADVANCED: "Configurações avançadas",
		INCARCERATED_PERSON_PLACEHOLDER: "Digite seu nome",
		CDC_PLACEHOLDER: "Insira o número do CDC",
		HEARING_TYPE_PLACEHOLDER: "Insira o tipo de audição",
		INCARCERATED_PERSON: "Pessoa encarcerada",
		CDC: "CDC",
		HEARING_TYPE: "Tipo de audição",
		SCHEDULE: "Agendar",
		PICKDATE: "Escolha uma data",
		STEP_DETAILS: "Detalhes",
		STEP_MODEL: "Modelo",
		CONTINUE: "Continuar",
		BACK: "Voltar",
		MODEL_TITLE: "Modelo de transcrição",
		MODEL_DESCRIPTION: "Choose the model everyone in this room starts with. You can lock it so participants keep it.",
		LOCK_MODEL: "Lock model for everyone",
		LOCK_MODEL_DESC: "Participants cannot change the transcription model in this room.",
		HOURS: "Horas",
		MINUTES: "Minutos",
		SECONDS: "Segundos",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "Falha na Exportação",
		TOAST_FAILED_DESCRIPTION: "Não é possível exportar uma transcrição vazia.",
		DOWNLOAD: "Baixar",
		DOWNLOAD_DESCRIPTION:
			"Selecione o formato para exportação e ative opções adicionais.",
		SELECT_FORMAT: "Selecione o formato",
		SELECT_FORMAT_PLACEHOLDER: "Selecione o formato de exportação",
		DOCUMENT: "Documento (.pdf)",
		SPREADSHEET: "Planilha (.csv)",
		AUDIO: "Áudio (.mp3)",
		DOCX: "Documento do Word (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "Tradução",
		BODY: "Gostaria de aplicar essa mudança em todas as transcrições deste usuário?",
		APPLY_TO_SPEAKER: "Aplicar somente a este usuário",
		APPLY_ONCE: "Aplicar apenas aqui",
		APPLY_TO_ALL: "Aplicar a todos os usuários",

		TRANSLATE: "Traduzir",
	},
	GUEST_FORM: {
		TITLE: "Acesso de Convidado",
		DESCRIPTION:
			"Digite seu endereço de e-mail para receber um link de login seguro",
		EMAIL_LABEL: "Endereço de E-mail",
		EMAIL_PLACEHOLDER: "Digite o endereço de e-mail",
		EMAIL_REQUIRED: "O endereço de e-mail é obrigatório",
		EMAIL_INVALID: "Por favor, digite um endereço de e-mail válido",
		SEND_LINK: "Enviar Link de Login",
		SUCCESS_TITLE: "Verifique seu E-mail",
		SUCCESS_DESCRIPTION:
			"Enviamos um link de login para seu endereço de e-mail. Clique no link para acessar a sala.",
		ERROR_TITLE: "Algo deu errado",
		ERROR_DESCRIPTION:
			"Falha ao enviar o link de login. Por favor, tente novamente.",
		CANCEL: "Cancelar",
	},
	START_DATE_TIME: "Data e Hora de Início",
	END_DATE_TIME: "Data e Hora de Término",
	REVERT_TO_ORIGINAL: "Reverter para Original",
	SELECTED_LANGUAGE: "Idioma Selecionado",
	TRANSLATION_INFO: "Algumas transcrições foram traduzidas do original.",
	INVITE_GUEST: "Convidar Convidado",
	INVITE_GUEST_DESCRIPTION:
		"Convide um usuário convidado para a sala inserindo seu nome e endereço de e-mail",
	CREATED_BY: "Criado por",
	VIEW_ALL: "Ver todos",
	LOBBY: {
		LOBBY: "Saguão",
		WAITING_IN_LOBBY: "{name} está aguardando no saguão",
		USERS_WAITING_IN_LOBBY:
			"Gerenciar usuários que estão aguardando no saguão.",
		SEND_INVITE: "Enviar convite",
		ADMIT: "Admitir",
		REJECT: "Rejeitar",
		NO_PARTICIPANTS: "Sem participantes no saguão.",
	},
	CLOSE: "Fechar",
	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"Experimente transcrição em tempo real com tecnologia avançada de reconhecimento de falantes. Perfeito para reuniões, entrevistas e conferências.",
		CAROUSEL_STORY_2:
			"Modo de alto contraste, fontes personalizáveis e suporte multi-idioma garantem que todos possam usar nossa plataforma efetivamente.",
		CAROUSEL_STORY_3:
			"Suas conversas são protegidas com segurança de nível empresarial. Junte-se a milhares de profissionais que confiam no uTranscribe.",
		CAROUSEL_STORY_4:
			"Escolha seu método de identificação abaixo e comece a transcrever em segundos. Nenhuma configuração complexa é necessária.",
		CDCR_TEAM_TITLE: "Equipe Tech Unicorn",
		CDCR_TEAM_SUBTITLE: "Membro Verificado",
		OR_CONTINUE_WITH: "ou continue com",
		GUEST_ACCESS_SUBTITLE: "Não é membro? Junte-se usando seu ID de reunião",
		WELCOME_TO: "Bem-vindo ao",
		CHOOSE_IDENTIFICATION: "Por favor, escolha sua identificação",
		NEED_HELP: "Precisa de ajuda? Conecte-se com nosso Suporte.",
		CALL_SUPPORT: "Ligue para 1-877-742-2135",
		EMAIL_SUPPORT: "Envie um e-mail para support@courtroom.tech",
	},
	SIZES: "Tamanhos",
	DIAGNOSTICS: "Diagnósticos",
	ROOM_BACKGROUND: "Fundo da Sala",
	NOT_AVAILABLE: "Não disponível",
	UNRECOGNIZED_SPEECH: "Fala não reconhecida",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"Esta transcrição não foi reconhecida. Por favor, verifique a qualidade do áudio e tente novamente.",
	UNDETECTED: "Não detectado",
	MICROPHONE_QUALITY_WARNING:
		"Por favor, verifique a qualidade do microfone para melhorar a precisão ou ajuste a distância do microfone",
	LOW_ACCURACY_WARNING: "Precisão baixa",
	UNKNOWN: "Desconhecido",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "Configurações de transcrição",
		GENERAL: "Geral",
		GENERAL_HINT: "Tema, fonte e idioma",
		MODE_HINT: "Comportamento de transcrição",
		MODEL_HINT: "Motor de processamento IA",
		MODE: "Modo",
		LIVE_TRANSCRIPTION: "Transcrição ao vivo",
		SEGMENTED_TRANSCRIPTION: "Transcrição segmentada",
		FINAL_TRANSCRIPTION: "Transcrição final",
		LIVE_DESC:
			"Veja uma transcrição ao vivo do seu próprio discurso num painel separado enquanto fala. O painel principal mostra a transcrição final de todos os oradores.",
		SEGMENTED_DESC:
			"Exibe uma transcrição temporária segmentada em tempo real, atualizando-se automaticamente para a versão final.",
		FINAL_DESC:
			"Mostra apenas a transcrição final no painel principal. A transcrição ao vivo não é exibida.",
		SPEED_VALUE: "Velocidade: {value}x",
		SPEED: "Velocidade",
		FONT_TEST:
			"O UTranscribe está a revolucionar a forma como captamos e compreendemos a fala.",
		FONT_SIZE: "Tamanho da fonte",
		SPEED_DESC: "Velocidade e atraso da transcrição",
		DELAY_DESC:
			"Velocidade {speed:number}x = atraso de {delay:number} segundos",
		MODEL: "Modelo",
		MODEL_TITLE: "Modelo de Transcrição",
		MODEL_DESC: "Selecione o modelo de IA usado para processar as suas transcrições.",
		MODEL_DEFAULT: "Padrão",
		MODEL_WHISPER: "Allicorn Model 1",
		MODEL_GPT4O: "Allicorn Model 2",
		MODEL_GPT4O_MINI: "Allicorn Model 3",
		MODEL_FAST: "Allicorn Model 4",
		MODEL_DEFAULT_DESC:
			"Serviço de diarização da Microsoft com processamento rápido e precisão confiável para a maioria dos casos de uso.",
		MODEL_DEFAULT_SHORT_DESC:
			"Diarização de oradores rápida e confiável para a maioria dos casos de uso.",
		MODEL_WHISPER_DESC:
			"Allicorn Model 1 com precisão aprimorada para ambientes de áudio complexos e vocabulário especializado.",
		MODEL_WHISPER_SHORT_DESC:
			"Alta precisão para áudio complexo e termos especializados.",
		MODEL_GPT4O_DESC:
			"Modelo de transcrição Allicorn Model 2 com a maior precisão e compreensão de linguagem.",
		MODEL_GPT4O_SHORT_DESC:
			"Maior precisão de transcrição e compreensão de linguagem.",
		MODEL_GPT4O_MINI_DESC:
			"Modelo de transcrição Allicorn Model 3 equilibrando precisão e velocidade.",
		MODEL_GPT4O_MINI_SHORT_DESC:
			"Precisão e velocidade de transcrição equilibradas.",
		MODEL_FAST_DESC:
			"Serviço de transcrição Allicorn Model 4 otimizado para processamento de baixa latência.",
		MODEL_FAST_SHORT_DESC:
			"Processamento de transcrição de baixa latência.",
		MODEL_ENHANCED: "Melhorado",
		MODEL_PREMIUM: "Premium",
		MODEL_BETA: "Beta",
		MODEL_BETA_TOOLTIP: "This feature is currently in beta. Expect occasional inaccuracies as we continue fine-tuning.",
		MODEL_LOCKED: "Model locked",
		MODEL_LOCKED_DESC: "The host fixed the transcription model when this room was created.",
		MODEL_LOCKED_HINT: "Locked by the room host.",
		DOMAIN_MATH_UNAVAILABLE: "Not available for the selected model.",
		DOMAIN_MATH: "Otimizado para matemática",
		DOMAIN_MATH_DESC:
			"Exibe símbolos e equações matemáticas faladas como notação matemática real em vez de texto simples.",
	},
	NO_AUDIO: "Nenhum áudio detectado",
	NO_AUDIO_DESC:
		"Seu microfone está ativado, mas nenhum áudio está sendo detectado. Verifique as configurações do microfone ou mude para outro microfone.",
	NO_TRANSCRIPTION: "Transcrições não geradas",
	NO_TRANSCRIPTION_DESC:
		"As transcrições não estão sendo geradas. Por favor, atualize a página.",
	SCROLLING_PAUSED: "Rolagem para baixo pausada",
	RESUME: "Retomar",
} satisfies BaseTranslation;

export default pt;
